export default __webpack_public_path__ + "static/media/PRODUCT_DOUBLE.f105efe8.jpg";